import { Container_Insights_Ages } from '@/graphql/types';

import { store } from './store';

export type ReeferAgesFilter = Container_Insights_Ages & {
  selected: boolean;
};

const setReeferAges = (reeferAges: Container_Insights_Ages[]) => {
  store.reeferAges = reeferAges.map((age) => ({ ...age, selected: false }));
};

const getReeferAge = (id: string): ReeferAgesFilter | null => {
  const reeferAge = store.reeferAges.find((age) => age.id === id);
  return reeferAge || null;
};

const setSelectedReeferAges = (ids: string[]) => {
  store.reeferAges.forEach((reeferAge) => {
    reeferAge.selected = ids.includes(reeferAge.id);
  });
};

const unselectReeferAge = (id: string) => {
  const reeferAge = store.reeferAges.find((age) => age.id === id);
  if (reeferAge) {
    reeferAge.selected = false;
  }
};

const selectAllReeferAges = () => {
  store.reeferAges.forEach((age) => {
    age.selected = true;
  });
};

const unselectAllReeferAges = () => {
  store.reeferAges.forEach((age) => {
    age.selected = false;
  });
};

export {
  setReeferAges,
  setSelectedReeferAges,
  getReeferAge,
  unselectReeferAge,
  selectAllReeferAges,
  unselectAllReeferAges,
};
